import { render, staticRenderFns } from "./DialogPortalPhotos.vue?vue&type=template&id=2cf44ad3"
import script from "./DialogPortalPhotos.vue?vue&type=script&lang=js"
export * from "./DialogPortalPhotos.vue?vue&type=script&lang=js"
import style0 from "./DialogPortalPhotos.vue?vue&type=style&index=0&id=2cf44ad3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports